import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import _ from "lodash";
import {
  getQualificationConfigurationByFormId,
  getAllDocumentChecklistByFormId,
  admissionAcademicProfileInsert,
  getAllQuota,
  getAllAdmissionProgramByFormId,
  getAllAdmissionFormConfigurationByFormId,
  getAllAdmissionSubjectGroupByFormId,
  getWorkingInstituteDetailsByStudentId,
  getOtherDetailsByStudentId,
  getResearchDetailsByStudentId,
  getExperienceDetailsByStudentId,
  getAcademicQuotaDetailsByStudentId,
  getInternshipDetails,
  getAllAdmissionFormList,
  getACPCdetailsByStudentId,
  getAllCounsellingDetailByStudentId,
  getDocumentVerificationStatusByStudentId,
  getEntranceExaminationDetails,
  getDegreeRegistrationDetails,
  getNeetDetails
} from "../../actions";
// import numberToText from "number-to-text";
import numberToWord from "../../utils/numberToWord";
const keys = require("../../config/keys");

const temp_neet = {
  Id: 0,
  rollNo: "",
  allIndiaRank: 0,
  applicationNo: "",
  neetScore: 0,
  IsDelete: 0
};

class AcademicInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allExperienceData: [],
      allResearchData: [],
      allDocumentList: [],
      allQualification: [],
      selectedPrograms: [],
      admissionProgram: [],
      allSubjectGroup: [],
      selectedQuota: [],
      academicQuota: [],
      entranceexaminationDetails: [],
      degreeRegistrationDetails: [],
      internship: [],
      neetDetails: temp_neet
    };
  }
  async componentWillMount() {
    this.props.getAllAdmissionFormList();

    const PromiseArry = [];

    if (this.props.FormId) {
      this.props.getAllAdmissionFormConfigurationByFormId(this.props.FormId);
      this.props.getAllQuota(this.props.FormId);
      PromiseArry.push(
        // this.props.getAllCounsellingDetailByStudentId(
        //   this.props.FormId,
        //   this.props.auth.userId
        // )
        this.props.getAllCounsellingDetailByStudentId(
          this.props.FormId,
          this.props.auth.userId,
          this.props.auth.admissionConfig.AyId
        )
      );
      PromiseArry.push(
        this.props.getACPCdetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getDocumentVerificationStatusByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getWorkingInstituteDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getOtherDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getResearchDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getExperienceDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getAllAdmissionSubjectGroupByFormId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getAllAdmissionProgramByFormId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getQualificationConfigurationByFormId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getAllDocumentChecklistByFormId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getAcademicQuotaDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getInternshipDetails(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getEntranceExaminationDetails(
          this.props.FormId,
          this.props.auth.userId
        )
      );

      PromiseArry.push(
        this.props.getDegreeRegistrationDetails(
          this.props.FormId,
          this.props.auth.userId
        )
      );

      PromiseArry.push(
        this.props.getNeetDetails(this.props.FormId, this.props.auth.userId)
      );
      await Promise.all(PromiseArry);

      var fromDataList = _.uniqBy(
        this.props.qualificationConfigList,
        "Qualification_ID"
      );
      var tempData = [];
      fromDataList.map((qual) => {
        var obj = { ...qual };
        var a = this.props.qualificationConfigList.filter(
          (i) =>
            i.Qualification_ID === qual.Qualification_ID &&
            i.ShowInDetailTable === 1
        );
        obj["subjectList"] = a;
        tempData.push(obj);
        return obj;
      });
      var subjectDataList = this.props.admissionSubjectGroupList.map((i) => {
        return i;
      });
    }

    var admissionProgram = this.props.admissionProgram.map((item) => {
      item.value = parseInt(item.CourseID, 10);
      item.label = item.ProgramName;
      return item;
    });
    var academicQuota = this.props.quotaList.map((item) => {
      item.value = parseInt(item.AdmQuotaId, 10);
      item.label = item.AdmQuota;
      return item;
    });
    var selectedQuota = this.props.academicQuotaList.map((item) => {
      item.value = parseInt(item.AdmQuotaId, 10);
      item.label = item.AdmQuota;
      return item;
    });
    var Defaultpcbm = ""
    try{

      Defaultpcbm =   tempData.length > 0 && tempData[0].subjectList.length>0
      ? tempData[0].subjectList.find(
          (i) =>
            i.Qual_Subjects.toLowerCase() === "maths" ||
            i.Qual_Subjects.toLowerCase() === "biology"
        ).Qual_Subjects
      : "-";

    }catch(err){
      console.log("err",err);
      Defaultpcbm = "-"
    }
    
     
    await this.setState({
      allDocumentList: _.sortBy(this.props.documentChecklist, "SeqNo"),
      allQualification: tempData,
      admissionProgram: admissionProgram,
      selectedPrograms: admissionProgram.filter((i) => parseInt(i.Id, 10)),
      allSubjectGroup: subjectDataList,
      selectedQuota: selectedQuota,
      academicQuota: academicQuota,
      allExperienceData: this.props.admissionExperienceDetails,
      allResearchData: this.props.admissionResearchDetails,
      entranceexaminationDetails: this.props.entranceExaminationDetails,
      internship: this.props.internshipDetails || [],
      degreeRegistrationDetails: this.props.degreeRegistrationDetails,
      neetDetails: this.props.neetDetails,
      Defaultpcbm:Defaultpcbm.toLowerCase() === "biology" ? "PCB" :"PCM"
    });

    if (this.props.admissionOtherDetails.length > 0) {
      await this.setState({
        isHostel:
          this.props.admissionOtherDetails[0].IsHostel === 1 ? "Yes" : "No",
        isTransport:
          this.props.admissionOtherDetails[0].IsTransport === 1 ? "Yes" : "No",
        otherDetailId: this.props.admissionOtherDetails[0].Id,
        proposedArea: this.props.admissionOtherDetails[0].ResearchArea_Title
      });
    }

    if (this.props.admissionWorkingDetails.length > 0) {
      await this.setState({
        nameOfDepartment: this.props.admissionWorkingDetails[0].DepartmentName,
        institution: this.props.admissionWorkingDetails[0].InstituteName,
        dateOfAppointment:
          this.props.admissionWorkingDetails[0].AppointmentDate !== null
            ? moment(
                this.props.admissionWorkingDetails[0].AppointmentDate
              ).format("DD-MM-YYYY")
            : undefined,
        designation: this.props.admissionWorkingDetails[0].DesignationName,
        periodOfService: this.props.admissionWorkingDetails[0].ServicePeriod,
        isNOCenclosed:
          this.props.admissionWorkingDetails[0].IsNOCenclosed === 1
            ? "Yes"
            : "No"
      });
    }
    if (this.props.admissionACPCdetails.length > 0) {
      await this.setState({
        RegistrationNo: this.props.admissionACPCdetails[0].RegistrationNo,
        MeritNo: this.props.admissionACPCdetails[0].MeritNo
      });
    }

    if (this.props.admissionVerifyDetails.length > 0) {
      await this.setState({
        AdmissionNo: this.props.admissionVerifyDetails[0].AdmissionNo,
        AdmissionDate:
          this.props.admissionVerifyDetails[0].AdmissionDate !== "" &&
          moment(this.props.admissionVerifyDetails[0].AdmissionDate).format(
            "DD-MM-YYYY"
          )
      });
    }
    if (this.props.admissionTotalFormFees.length > 0) {
      await this.setState({
        FormFees: this.props.admissionTotalFormFees[0].FormFees,
        PaidAmount: this.props.admissionTotalFormFees[0].PaidAmount,
        PendingAmount: this.props.admissionTotalFormFees[0].PendingAmount
      });
    }
  }

  render() {
    return (
      <div className="academisProfilePrint">
        <div className="pageBreakheader">
          <header className="print-header displayPrintOnly">
            {this.props.admissionFormList.length > 0 && (
              <div>
                {this.props.admissionFormList
                  .filter((data) => {
                    return data.ID === parseInt(this.props.FormId, 10);
                  })
                  .map((item, index) => {
                    return (
                      <div className="documentData" key={index}>
                        <h2 className="text-center"> {item.FormGroupName}</h2>

                        <ul className="documentDataList">
                          <li>
                            <strong>Application No</strong> :{" "}
                            {this.state.AdmissionNo || ""}
                          </li>
                          <li className="text-capitalize">
                            <strong>Applicant Name</strong> :{" "}
                            {this.props.userDetails.FullUserName || ""}
                          </li>
                        </ul>
                        <p className="formDate">
                          <strong>Application Date</strong> :{" "}
                          {this.state.AdmissionDate}
                          <br />
                          <strong>Form Fees</strong> :{" "}
                          {this.state.FormFees ? `₹${this.state.FormFees}` : ""}
                        </p>
                      </div>
                    );
                  })}
              </div>
            )}
          </header>

          {this.props.admissionFormConfiguration.filter(
            (item) =>
              item.DisplayStatus === 1 && item.AdmFormGroupSectionId === 1
          ).length > 0 && (
            <div>
              {this.state.selectedPrograms.length > 0 && (
                <div className="program-list">
                  <h5 className="inner-title mb-3 mt-1">Programs</h5>
                  <table className="mb-3 table table-bordered">
                    <tbody>
                      <tr>
                        {this.state.selectedPrograms.map((item, index) => {
                          return (
                            <td key={index}>
                              <span className="badge badge-primary">
                                {index + 1}
                              </span>
                              <span>{item.ProgramName}</span>
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                  <h5 className="inner-title mb-2 mt-1">Admission Type</h5>
                  <p>
                    <i className="fa fa-arrow-right" aria-hidden="true" />{" "}
                    {this.state.selectedPrograms[0].AdmissionTypeName}
                  </p>
                </div>
              )}
              <div className="mb-3 ">
                <h5 className="inner-title mb-3 mt-1">Qualification Details</h5>
                <table className="table table-bordered qulification-table ">
                  <tbody>
                    <tr className="table-light">
                      <th style={{ width: "160px" }} className="align-middle">
                        Degree
                      </th>
                      <th className="align-middle">Stream</th>
                      {/* <th className="align-middle">Month-Year</th> */}
                      <th className="align-middle">Month-Year of Passing</th>
                      {/* <th className="align-middle">Board</th> */}
                      <th className="align-middle">Board/University</th>
                      {/* <th className="align-middle">Institute Name</th> */}
                      <th className="align-middle">School/College</th>
                      {/* <th className="align-middle">Medium</th> */}
                      <th className="align-middle">Marks Type</th>
                      <th className="align-middle">Scored</th>
                      <th className="align-middle">Max Marks</th>
                      <th className="align-middle">Percentage</th>
                    </tr>

                    {_.sortBy(this.state.allQualification, "SeqNo")
                      .filter((i) => !i.IsCet)
                      .map((qualification, qualIndex) => {
                        return (
                          <tr key={qualIndex}>
                            <td className="align-middle">
                              {qualification.Adm_QualficationName}
                            </td>
                            <td className="align-middle">
                              {qualification.StreamName || ""}
                            </td>
                            <td className="align-middle">
                              {qualification.PassingMonthYear || ""}
                            </td>
                            <td className="align-middle">
                              { ![10, 11].includes(
                                    qualification.Qualification_ID
                                  ) ?  qualification.University_Board : qualification.BoardFullName ||""}
                            </td>
                            <td className="align-middle">
                              {qualification.InstituteName || ""}
                            </td>
                            {/* <td className="align-middle">
                              {qualification.Medium || ""}
                            </td> */}
                            <td className="align-middle">
                              {qualification.MarksTypeName || ""}
                            </td>
                            <td className="align-middle">
                              {qualification.Percentage_Grade || ""}
                            </td>
                            <td className="align-middle">
                              {Math.round(qualification.PercentageOutOf) || ""}
                            </td>
                            <td className="align-middle">
                              {qualification.Percentage_Grade || ""}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>

                {_.sortBy(this.state.allQualification, "SeqNo")
                  .filter((i) => !i.IsCet && i.ShowInDetailTable === 1)
                  .map((qualification, qualIndex) => {
                    return (
                      <div key={qualIndex}>
                        <h5 className="inner-title mb-3 mt-2">
                          {qualification.Adm_QualficationName} Subject Details{" "}
                          {/* <strong>
                            (In marks cards containing non segregated theory
                            &amp; practical marks, enter total marks in theory
                            field &amp; '0' in practical field)
                          </strong> */}
                          <strong>
                            (In marks cards containing non segregated theory
                            &amp; practical marks, enter total marks in theory
                            field &amp; 'Leave blank' in practical field)
                          </strong>
                        </h5>
                        <table className="table table-bordered qulification-table print-acadprofile">
                          <tbody>
                            <tr className="table-light">
                              <th
                                rowSpan="2"
                                className="align-middle"
                                style={{ width: "250px" }}
                              >
                                Subjects
                              </th>
                              <th
                                colSpan="2"
                                className="align-middle text-center"
                              >
                                Theory
                              </th>
                              <th
                                colSpan="2"
                                className="align-middle text-center"
                              >
                                Practical
                              </th>
                              <th
                                rowSpan="2"
                                className="align-middle text-center"
                                style={{ width: "160px" }}
                              >
                                Total
                              </th>
                            </tr>
                            <tr className="text-center">
                              <th className="align-middle">Max Marks</th>
                              <th className="align-middle">Marks Scored</th>
                              <th className="align-middle">Max Marks</th>
                              <th className="align-middle">Marks Scored</th>
                            </tr>

                            {qualification.subjectList.map(
                              (subject, subjectIndex) => {
                                return (
                                  <tr key={subjectIndex}>
                                    <td className="align-middle">
                                      {subject.Qual_Subjects === "Biology"
                                        ? qualification.pcbm == "PCM"
                                          ? "Maths"
                                          : "Biology"
                                        : subject.Qual_Subjects}
                                    </td>
                                    <td className="align-middle text-center">
                                      {Math.round(subject.MarksTotal_Theory) ||
                                        ""}
                                    </td>
                                    <td className="align-middle text-center">
                                      {Math.round(subject.MarksScored_Theory) ||
                                        ""}
                                    </td>
                                    <td className="align-middle text-center">
                                      {Math.round(
                                        subject.MarksTotal_Practical
                                      ) || ""}
                                    </td>
                                    <td className="align-middle text-center">
                                      {Math.round(
                                        subject.MarksScored_Practical
                                      ) || ""}
                                    </td>
                                    <td className="align-middle text-center">
                                      {Math.round(subject.TotalScored) || ""}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                          {this.state.allQualification.some(
                              (i) =>
                                // i.Qualification_ID === 10 ||
                                i.Qualification_ID === 11
                            )&& <tfoot>
                            <th
                              colSpan={5}
                              style={{ textAlign: "right" }}
                            >
                              {/* {`${qualification.pcbm} %`} */}
                              {`${qualification.pcbm ? qualification.pcbm : this.state.Defaultpcbm} %`}
                            </th>
                            <th className="align-middle text-center">
                              {qualification.pcbmPer?qualification.pcbmPer:"--"}
                            </th>
                          </tfoot>}
                        </table>
                      </div>
                    );
                  })}
              </div>
              {this.state.allSubjectGroup.length > 0 && (
                <div>
                  <h5 className="inner-title mb-3">Subject Group Details</h5>
                  {this.state.allSubjectGroup.map((subjectGroup, subIndex) => {
                    return (
                      <div className="col-sm-4 row" key={subIndex}>
                        <table className="table table-bordered qulification-table print-acadprofile">
                          <tbody>
                            <tr className="table-light">
                              <th
                                className="align-middle"
                                style={{ width: "250px" }}
                              >
                                Group
                              </th>
                              <th
                                className="align-middle"
                                style={{ width: "160px" }}
                              >
                                Total
                              </th>
                            </tr>

                            <tr>
                              <td className="align-middle">
                                {subjectGroup.MeritSubjGroupName}
                              </td>
                              <td className="align-middle">
                                {Math.round(subjectGroup.TotalScored) || ""}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    );
                  })}
                </div>
              )}

              <div className="mb-3">
                {_.sortBy(this.state.allQualification, "SeqNo")
                  .filter((i) => i.IsCet)
                  .map((qualification, qualIndex) => {
                    return (
                      <div key={qualIndex}>
                        <h5 className="inner-title mb-3 mt-1">
                          {qualification.Adm_QualficationName} Details
                        </h5>
                        {qualification.IsCet === 1 && (
                          <table className="table table-bordered qulification-table print-acadprofile">
                            <tbody>
                              <tr className="table-light">
                                <th className="align-middle">Examination</th>
                                <th className="align-middle">Seat Number</th>
                                <th className="align-middle">Marks Obtained</th>
                                <th className="align-middle">Marks Out OF</th>
                                <th className="align-middle">
                                  Percentile Score
                                </th>
                                <th className="align-middle">
                                  All India Rank(Overall)
                                </th>
                                <th className="align-middle">Category Rank</th>
                              </tr>
                              <tr>
                                <td className="align-middle">
                                  {qualification.Adm_QualficationName}
                                </td>
                                <td className="align-middle">
                                  {qualification.SeatNo || ""}
                                </td>
                                <td className="align-middle">
                                  {/* {qualification.Percentage_Grade || ""} */}
                                  {qualification.overall_obtainedMarks || ""}
                                </td>
                                <td className="align-middle">
                                  {qualification.PercentageOutOf || ""}
                                </td>
                                <td className="align-middle">
                                  {qualification.Percentile || ""}
                                </td>
                                <td className="align-middle">
                                  {qualification.Rank || ""}
                                </td>
                                <td className="align-middle">
                                  {qualification.CategoryRank || ""}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        )}
                        {qualification.IsCet === 1 &&
                          qualification.ShowInDetailTable === 1 && (
                            <div>
                              <h5 className="inner-title mb-3 mt-2">
                                {qualification.Adm_QualficationName} Subject
                                Details{" "}
                                {/* <strong>
                                  (In marks cards containing non segregated
                                  theory &amp; practical marks, enter total
                                  marks in theory field &amp; '0' in practical
                                  field)
                                </strong> */}
                                <strong>
                                  (In marks cards containing non segregated
                                  theory &amp; practical marks, enter total
                                  marks in theory field &amp; 'Leave blank' in
                                  practical field)
                                </strong>
                              </h5>
                              <table className="table table-bordered qulification-table print-acadprofile">
                                <tbody>
                                  <tr className="table-light">
                                    <th
                                      className="align-middle"
                                      style={{ width: "250px" }}
                                    >
                                      Subjects
                                    </th>
                                    <th className="align-middle text-center">
                                      Max Marks
                                    </th>
                                    <th className="align-middle text-center">
                                      Marks Scored
                                    </th>
                                  </tr>
                                  {qualification.subjectList.map(
                                    (subject, subjectIndex) => {
                                      return (
                                        <tr key={subjectIndex}>
                                          <td className="align-middle">
                                            {subject.Qual_Subjects}
                                          </td>
                                          <td className="align-middle text-center">
                                            {subject.MarksTotal_Theory || ""}
                                          </td>
                                          <td className="align-middle text-center">
                                            {subject.MarksScored_Theory || ""}
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </tbody>
                              </table>
                            </div>
                          )}
                      </div>
                    );
                  })}
              </div>
            </div>
          )}

          {this.props.admissionFormConfiguration.filter(
            (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 14
          ).length > 0 ||
          this.props.admissionFormConfiguration.filter(
            (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 15
          ).length > 0
            ? (this.state.RegistrationNo !== null ||
                this.state.MeritNo !== null) && (
                <div className="mb-2 mt-3">
                  <h5 className="inner-title mb-3">ACPC Details</h5>
                  <div className="row ">
                    {this.state.RegistrationNo !== null && (
                      <div className="col-lg-6 col-print-6">
                        <p>
                          <strong>ACPC Registration No : </strong>
                          <span>{this.state.RegistrationNo}</span>
                        </p>
                      </div>
                    )}
                    {this.state.MeritNo !== null && (
                      <div className="col-lg-6 col-print-6">
                        <p>
                          <strong>ACPC Merit No : </strong>
                          <span>{this.state.MeritNo}</span>
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              )
            : ""}

          {this.props.admissionFormConfiguration.filter(
            (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 19
          ).length > 0 && (
            <div className="mb-3">
              <h5 className="inner-title mb-3">{`Neet Registration Details`}</h5>
              <table className="table table-bordered qulification-table mb-0">
                <thead>
                  <tr className="table-light">
                    <th className="align-middle">{`Roll No`}</th>
                    <th className="align-middle">{`All India Rank`}</th>
                    <th className="align-middle">{`Application No`}</th>
                    <th className="align-middle">{`Neet Score`}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="align-middle">
                      {this.state.neetDetails ? this.state.neetDetails.rollNo : ''}
                    </td>
                    <td className="align-middle">
                      {this.state.neetDetails ? this.state.neetDetails.allIndiaRank : ''}
                    </td>
                    <td className="align-middle">
                      {this.state.neetDetails ? this.state.neetDetails.applicationNo : ''}
                    </td>
                    <td className="align-middle">
                      {this.state.neetDetails ? this.state.neetDetails.neetScore : ''}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {this.props.admissionFormConfiguration.filter(
            (item) =>
              item.DisplayStatus === 1 && item.AdmFormGroupSectionId === 2
          ).length > 0 &&
            this.state.allExperienceData.length > 0 && (
              <div className="mb-3">
                <h5 className="inner-title mb-3">Experience Details</h5>
                <table className="table table-bordered qulification-table mb-0 ">
                  <tr className="table-light">
                    <th className="align-middle">Position</th>
                    <th className="align-middle">Organisation</th>
                    <th className="align-middle">Assignment</th>
                    <th className="align-middle">Period</th>
                  </tr>

                  {this.state.allExperienceData.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className="align-middle">{item.Position}</td>
                        <td className="align-middle">{item.Organisation}</td>
                        <td className="align-middle">{item.WorkDetails}</td>
                        <td className="align-middle">{item.WorkDuration}</td>
                      </tr>
                    );
                  })}
                </table>
              </div>
            )}

          {this.props.admissionFormConfiguration.filter(
            (item) =>
              item.DisplayStatus === 1 && item.AdmFormGroupSectionId === 3
          ).length > 0 &&
            this.state.allResearchData.length > 0 && (
              <div className="mb-3">
                <h5 className="inner-title mb-3">Research Details (If PHD)</h5>
                <table className="table table-bordered qulification-table mb-0">
                  <tr className="table-light">
                    <th className="align-middle">Title/Publication</th>
                    <th className="align-middle">Name of Journal</th>
                    <th className="align-middle">Vol/Edition</th>
                    <th className="align-middle">National/International</th>
                  </tr>

                  {this.state.allResearchData.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className="align-middle">
                          {item.PublicationTitle}
                        </td>
                        <td className="align-middle">
                          {item.JournalName_Published}
                        </td>
                        <td className="align-middle">
                          {item.No_Vol_Edition_Date}
                        </td>
                        <td className="align-middle">{item.ResearchType}</td>
                      </tr>
                    );
                  })}
                </table>
              </div>
            )}

          {this.props.admissionFormConfiguration.filter(
            (item) =>
              item.DisplayStatus === 1 && item.AdmFormGroupSectionId === 3
          ).length > 0 &&
            this.props.admissionOtherDetails.length > 0 &&
            this.state.proposedArea !== "" && (
              <table className="table table-bordered qulification-table mb-3">
                <tbody>
                  <tr className="table-light">
                    <th className="align-middle">
                      Proposed Research Area / Title for Ph.D Studies
                    </th>
                  </tr>

                  <tr>
                    <td>{this.state.proposedArea || ""}</td>
                  </tr>
                </tbody>
              </table>
            )}

          {this.props.admissionFormConfiguration.filter(
            (item) =>
              item.DisplayStatus === 1 && item.AdmFormGroupSectionId === 5
          ).length > 0 &&
            this.props.admissionWorkingDetails.length > 0 && (
              <div className="mb-3">
                <h5 className="inner-title  mb-3">
                  Details of In-service Candidates (for those working in
                  Institute)
                </h5>
                <table className="table table-bordered qulification-table mb-0">
                  <tbody>
                    <tr className="table-light">
                      <th className="align-middle">Name Of The Department</th>
                      <th className="align-middle">
                        Name Of The Institution/College
                      </th>
                      <th className="align-middle">Date Of Appointment</th>
                      <th className="align-middle">Present Designation</th>
                      <th className="align-middle">Period of Service</th>
                      <th className="align-middle">Is NOC Enclosed?</th>
                    </tr>

                    <tr>
                      <td className="align-middle">
                        {this.state.nameOfDepartment || ""}
                      </td>
                      <td className="align-middle">
                        {this.state.institution || ""}
                      </td>
                      <td className="align-middle">
                        {this.state.dateOfAppointment}
                      </td>
                      <td className="align-middle">
                        {this.state.designation || ""}
                      </td>
                      <td className="align-middle">
                        {this.state.periodOfService || ""}
                      </td>
                      <td>{this.state.isNOCenclosed}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

          {this.props.admissionFormConfiguration.filter(
            (item) =>
              item.DisplayStatus === 1 && item.AdmFormGroupSectionId === 16
          ).length > 0 && (
            <div className="mb-3">
              <h5 className="inner-title  mb-3">Internship Details</h5>
              <table className="table table-bordered qulification-table mb-3">
                <thead>
                  <tr className="table-light">
                    <th className="align-middle">{`From Date`}</th>
                    <th className="align-middle">{`To Date`}</th>
                    <th>{`Place`}</th>
                    <th>{`Total Days`}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.internship && this.state.internship.map((item) => (
                    <tr>
                      <td>{moment(item.fromDate).format("DD-MM-YYYY")}</td>
                      <td>{moment(item.toDate).format("DD-MM-YYYY")}</td>
                      <td>{item.place}</td>
                      <td>{item.totalDays}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {this.props.admissionFormConfiguration.filter(
            (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 17
          ).length > 0 && (
            <div>
              <h4 className="inner-title  mb-3">{`Entrance Examination Details`}</h4>
              <div className="row mb-4">
                <div className="col-lg-12">
                  <table className="table table-bordered qulification-table mb-0">
                    <thead>
                      <tr>
                        <td>{`Exam`}</td>
                        <td>{`Roll No`}</td>
                        <td>{`Application No`}</td>
                        <td>{`Score`}</td>
                        <td>{`Rank`}</td>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.entranceexaminationDetails
                        .filter((x) => x.IsDelete === 0)
                        .map((item) => (
                          <tr key={item.Id}>
                            <td>{item.examName}</td>
                            <td>{item.rollNo}</td>
                            <td>{item.applicationNo}</td>
                            <td>{item.score}</td>
                            <td>{item.rankScored}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {this.props.admissionFormConfiguration.filter(
            (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 18
          ).length > 0 && (
            <div>
              <h4 className="inner-title  mb-3">{`Degree Registration Details`}</h4>
              <div className="row mb-4">
                <div className="col-lg-12">
                  <table className="table table-bordered qulification-table mb-0">
                    <thead>
                      <tr>
                        <td>{`Degree Name`}</td>
                        <td>{`Council Name`}</td>
                        <td>{`Registration Number`}</td>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.degreeRegistrationDetails.map((item) => (
                        <tr key={item.Id}>
                          <td>{item.degreeName}</td>
                          <td>{item.councilName}</td>
                          <td>{item.registrationNumber}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {this.props.admissionFormConfiguration.filter(
            (item) =>
              item.DisplayStatus === 1 && item.AdmFormGroupSectionId === 6
          ).length > 0 &&
            this.props.admissionOtherDetails.length > 0 && (
              <div className="mb-3">
                <h5 className="inner-title  mb-3">Other Details</h5>
                <table className="table table-bordered qulification-table mb-3">
                  <tbody>
                    <tr className="table-light">
                      <th className="align-middle">
                        Do you need Hostel Accommodation?
                      </th>
                      <th className="align-middle">
                        Do you need Transport Facility?
                      </th>
                    </tr>

                    <tr>
                      <td>{this.state.isHostel}</td>
                      <td>{this.state.isTransport}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

          {/* {this.props.admissionFormConfiguration.filter(
            (item) =>
              item.DisplayStatus === 1 && item.AdmFormGroupSectionId === 6
          ).length > 0 &&
            this.props.admissionOtherDetails.length > 0 &&
            this.state.selectedQuota.length > 0 && (
              <div className="mb-2">
                <h5 className="inner-title  mb-3">Applying Through</h5>
                <table className="mb-1 table table-bordered mb-0">
                  <tbody>
                    <tr>
                      {this.state.selectedQuota.map((i, index) => {
                        return (
                          <td className="align-middle" key={index}>
                            {`${index + 1}. ${i.AdmQuota}`}
                          </td>
                        );
                      })}
                    </tr>
                  </tbody>
                </table>
              </div>
            )} */}

          {this.props.admissionFormConfiguration.filter(
            (item) =>
              item.DisplayStatus === 1 && item.AdmFormGroupSectionId === 4
          ).length > 0 &&
            this.state.allDocumentList.length > 0 && (
              <div>
                <h5 className="inner-title  mb-3">Document Check List</h5>
                <table className="table table-bordered qulification-table mb-4">
                  <tbody>
                    <tr className="table-light">
                      <th className="align-middle">Document Name</th>
                      <th className="align-middle" width="160px">
                        Uploaded Document
                      </th>
                    </tr>

                    {this.state.allDocumentList
                      //.filter(i => i.UploadedDocPath)
                      .map((item, index) => {
                        return (
                          <tr key={index}>
                            <td className="align-middle">
                              {item.DocumentCheckListName}
                              {item.documentFlag === 1 && (
                                <span className="required-docs" />
                              )}
                            </td>
                            <td className="align-middle text-center">
                              {item.UploadedDocName !== "" && (
                                <span>
                                  {item.UploadedDocName ? "Yes" : "No"}
                                </span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            )}
        </div>

        <div className="pageBreakheader">
          <header className="print-header displayPrintOnly">
            {this.props.admissionFormList.length > 0 && (
              <div>
                {this.props.admissionFormList
                  .filter((data) => {
                    return data.ID === parseInt(this.props.FormId, 10);
                  })
                  .map((item, index) => {
                    return (
                      <div className="documentData" key={index}>
                        <h2 className="text-center"> {item.FormGroupName}</h2>
                        <ul className="documentDataList">
                          <li>
                            <strong>Application No</strong> :{" "}
                            {this.state.AdmissionNo || ""}
                          </li>
                          <li className="text-capitalize">
                            <strong>Applicant Name</strong> :{" "}
                            {this.props.userDetails.FullUserName || ""}
                          </li>
                        </ul>
                        <p className="formDate">
                          <strong>Application Date</strong> :{" "}
                          {this.state.AdmissionDate}
                          <br />
                          <strong>Form Fees</strong> :{" "}
                          {this.state.FormFees ? `₹${this.state.FormFees}` : ""}
                        </p>
                      </div>
                    );
                  })}
              </div>
            )}
          </header>

          {keys.websiteSetting.signUpContent === "nvu" &&
            this.props.admissionDocumentVerificationStatus.length > 0 && (
              <div className="printDocVerifyStatus">
                <h5 className="inner-title mb-3">Document Verification</h5>
                <table className="table table-bordered qulification-table mb-0 ">
                  <thead>
                    <tr className="table-light">
                      <th className="align-middle">Verification Status</th>
                      <th className="align-middle">Verification Date </th>
                      <th className="align-middle">Verified By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.admissionDocumentVerificationStatus.map(
                      (item, dIndex) => {
                        return (
                          <tr key={dIndex}>
                            <td className="align-middle">
                              {item.DocumentVerifyStatusName}
                            </td>
                            <td className="align-middle">
                              {item.IsVerifyDate !== null
                                ? moment(item.IsVerifyDate).format("DD-MM-YYYY")
                                : ""}
                            </td>
                            <td className="align-middle">{item.VerifiedBy}</td>
                          </tr>
                        );
                      }
                    )}
                  </tbody>
                </table>
              </div>
            )}
          {keys.websiteSetting.signUpContent === "nvu" &&
            this.props.admissionCounsellingDetail.length > 0 && (
              <div className="printDocVerifyStatus">
                <h5 className="inner-title mb-3">Counselling Verification</h5>
                <table className="table table-bordered qulification-table mb-0 ">
                  <thead>
                    <tr className="table-light">
                      <th className="align-middle">Program Name</th>
                      <th className="align-middle">Counselling Status</th>
                      <th className="align-middle">Counselling Date </th>
                      <th className="align-middle">Counselling By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.admissionCounsellingDetail.map(
                      (item, cIndex) => {
                        return (
                          <tr key={cIndex}>
                            <td className="align-middle">{item.CourseName}</td>
                            <td className="align-middle">
                              {item.CounselingStatus === 1
                                ? "Approved"
                                : "Provisional Approved"}
                            </td>
                            <td className="align-middle">
                              {item.VerificationDate
                                ? moment(item.VerificationDate).format(
                                    "DD-MM-YYYY"
                                  )
                                : ""}
                            </td>
                            <td className="align-middle">{item.VerifiedBy}</td>
                          </tr>
                        );
                      }
                    )}
                  </tbody>
                </table>
              </div>
            )}

          {this.props.admissionFormList.length > 0 && (
            <div>
              <h5 className="inner-title mb-2">Declaration by the Applicant</h5>
              {this.props.admissionFormList
                .filter((data) => {
                  return data.ID === parseInt(this.props.FormId, 10);
                })
                .map((item, index) => {
                  return (
                    <div className="documentData" key={index}>
                      <div
                        dangerouslySetInnerHTML={{ __html: item.Declaration }}
                      />
                    </div>
                  );
                })}
            </div>
          )}
          <hr />

          <div className="row">
            <div className="col-sm-12 printPaySlip">
              <p className="text-center">
                <strong>[Institution Copy]</strong>
              </p>
              <div className="printPaySlip mb-0">
                <h5 className="inner-title mb-3 mt-3">
                  {keys.websiteSetting.PaymetnAcknowledgement}
                </h5>
              </div>
            </div>
            <div className="col-lg-12 printPaySlipReciept">
              <div className="row">
                <div className="col-lg-7 col-print-7 printPaySlip">
                  <p>
                    <strong>Application No</strong> :{" "}
                    {this.state.AdmissionNo || ""}
                  </p>
                  <p>
                    <strong>Date</strong> : {this.state.AdmissionDate || ""}
                  </p>
                  <p>
                    <strong>Amount(Rs)</strong> :{" "}
                    {this.state.PendingAmount > 0
                      ? `₹${this.state.PendingAmount}`
                      : `₹${this.state.PaidAmount}`}
                  </p>
                  <p>
                    <strong>Amount In Words</strong> :{" "}
                    {this.state.PendingAmount > 0 ? (
                      <span className="text-capitalize">
                        {numberToWord(this.state.PendingAmount) || ""} Only.
                      </span>
                    ) : (
                      this.state.PaidAmount !== undefined && (
                        <span className="text-capitalize">
                          {numberToWord(this.state.PaidAmount) || ""} Only.
                        </span>
                      )
                    )}
                  </p>
                  <div className="printPaySlip">
                    {this.state.selectedPrograms.length > 0 && (
                      <div className="printprogram-list">
                        <div>
                          <strong>Prefered Programs</strong> :
                          <p>
                            {this.state.selectedPrograms.map((item, index) => {
                              return (
                                <span key={index}>{item.ProgramName}</span>
                              );
                            })}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="printPaySlip mb-0">
                    <p className=" mb-1">
                      <strong>Received With Thanks </strong> :
                      <span className="print-username">
                        {this.props.userDetails !== undefined &&
                          this.props.userDetails.FullUserName}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="col-lg-5 col-print-5">
                  <div className="printPaySlip">
                    <p className="mb-1">
                      <strong>Bank Name : </strong>
                    </p>
                    <p className="mb-1">
                      <strong>Ref No : </strong>
                    </p>
                    <p className="mb-1">
                      <strong>Ref Date : </strong>
                    </p>
                    <p className="paymenttypelist mt-2">
                      {/* <strong>Payment Mode : </strong> */}

                      {/* <span>CASH</span> */}
                      {keys.websiteSetting.signUpContent !== "nvu" && (
                        <span>CHEQUE</span>
                      )}
                      <span>DD</span>
                      {keys.websiteSetting.signUpContent !== "nvu" && (
                        <span>ONLINE</span>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 mt-2">
              <p className="mb-1">
                <strong>Sign</strong>
              </p>
              <p className="mb-1">
                <strong>For : </strong>
                _______________________________________
              </p>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 printPaySlip">
              <p className="text-center">
                <strong>[Student Copy]</strong>
              </p>
              <div className="printPaySlip mb-0">
                <h5 className="inner-title mb-3 mt-3">
                  {keys.websiteSetting.PaymetnAcknowledgement}
                </h5>
              </div>
            </div>
            <div className="col-lg-12 printPaySlipReciept">
              <div className="row">
                <div className="col-lg-7 col-print-7 printPaySlip">
                  <p>
                    <strong>Application No</strong> :{" "}
                    {this.state.AdmissionNo || ""}
                  </p>
                  <p>
                    <strong>Date</strong> : {this.state.AdmissionDate || ""}
                  </p>
                  <p>
                    <strong>Amount(Rs)</strong> :{" "}
                    {this.state.PendingAmount > 0
                      ? `₹${this.state.PendingAmount}`
                      : `₹${this.state.PaidAmount}`}
                  </p>
                  <p>
                    <strong>Amount In Words</strong> :{" "}
                    {this.state.PendingAmount > 0 ? (
                      <span className="text-capitalize">
                        {numberToWord(this.state.PendingAmount) || ""} Only.
                      </span>
                    ) : (
                      this.state.PaidAmount !== undefined && (
                        <span className="text-capitalize">
                          {numberToWord(this.state.PaidAmount) || ""} Only.
                        </span>
                      )
                    )}
                  </p>
                  <div className="printPaySlip">
                    {this.state.selectedPrograms.length > 0 && (
                      <div className="printprogram-list">
                        <div>
                          <strong>Prefered Programs</strong> :
                          <p>
                            {this.state.selectedPrograms.map((item, index) => {
                              return (
                                <span key={index}>{item.ProgramName}</span>
                              );
                            })}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="printPaySlip mb-0">
                    <p className=" mb-1">
                      <strong>Received With Thanks </strong> :
                      <span className="print-username">
                        {this.props.userDetails !== undefined &&
                          this.props.userDetails.FullUserName}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="col-lg-5 col-print-5">
                  <div className="printPaySlip">
                    <p className="mb-1">
                      <strong>Bank Name : </strong>
                    </p>
                    <p className="mb-1">
                      <strong>Ref No : </strong>
                    </p>
                    <p className="mb-1">
                      <strong>Ref Date : </strong>
                    </p>
                    <p className="paymenttypelist mt-2">
                      {/* <strong>Payment Mode : </strong> */}

                      {/* <span>CASH</span> */}
                      {keys.websiteSetting.signUpContent !== "nvu" && (
                        <span>CHEQUE</span>
                      )}
                      <span>DD</span>
                      {keys.websiteSetting.signUpContent !== "nvu" && (
                        <span>ONLINE</span>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 mt-2">
              <p className="mb-1">
                <strong>Sign</strong>
              </p>
              <p className="mb-4">
                <strong>For : </strong>
                _______________________________________
              </p>
            </div>

            <div className="col-lg-12 mt-2">
              <p className="mb-4 border-top pt-2">
                <strong>Note: </strong>
                <span>
                  For offline payment submit receipt along with cheque/DD at
                  Account section, Sumandeep Vidyapeeth and get it signed &amp;
                  sealed before the last date for application.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps({
  auth,
  update,
  qualificationConfigList,
  systemConfig,
  documentChecklist,
  quotaList,
  admissionProgram,
  admissionFormConfiguration,
  admissionSubjectGroupList,
  admissionExperienceDetails,
  admissionOtherDetails,
  admissionResearchDetails,
  admissionWorkingDetails,
  academicQuotaList,
  admissionFormList,
  userDetails,
  admissionACPCdetails,
  admissionTotalFormFees,
  admissionVerifyDetails,
  admissionStudentStatusDetails,
  admissionCounsellingDetail,
  admissionDocumentVerificationStatus,
  internshipDetails,
  entranceExaminationDetails,
  degreeRegistrationDetails,
  neetDetails
}) {
  return {
    auth,
    update,
    qualificationConfigList,
    systemConfig,
    documentChecklist,
    quotaList,
    admissionProgram,
    admissionFormConfiguration,
    admissionSubjectGroupList,
    admissionExperienceDetails,
    admissionOtherDetails,
    admissionResearchDetails,
    admissionWorkingDetails,
    academicQuotaList,
    admissionFormList,
    userDetails,
    admissionACPCdetails,
    admissionTotalFormFees,
    admissionVerifyDetails,
    admissionStudentStatusDetails,
    admissionCounsellingDetail,
    admissionDocumentVerificationStatus,
    internshipDetails,
    entranceExaminationDetails,
    degreeRegistrationDetails,
    neetDetails
  };
}
export default connect(mapStateToProps, {
  getQualificationConfigurationByFormId,
  getAllDocumentChecklistByFormId,
  admissionAcademicProfileInsert,
  getAllQuota,
  getAllAdmissionProgramByFormId,
  getAllAdmissionFormConfigurationByFormId,
  getAllAdmissionSubjectGroupByFormId,
  getWorkingInstituteDetailsByStudentId,
  getOtherDetailsByStudentId,
  getResearchDetailsByStudentId,
  getExperienceDetailsByStudentId,
  getAcademicQuotaDetailsByStudentId,
  getInternshipDetails,
  getAllAdmissionFormList,
  getACPCdetailsByStudentId,
  getAllCounsellingDetailByStudentId,
  getDocumentVerificationStatusByStudentId,
  getEntranceExaminationDetails,
  getDegreeRegistrationDetails,
  getNeetDetails
})(AcademicInfo);



// WEBPACK FOOTER //
// ./src/components/StudentAccount/AcademicInfoPrint.js